import type { ReactNode } from 'react';

export const symbol_custom_typography: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M512-160v50q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q452-97.25 452-110v-160q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v50h298q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H512Zm-362 0q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h213q13 0 21 8.68 8 8.67 8 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm226-364h209l38 104q3 8.8 10.5 14.4t17.63 5.6Q668-400 677-413.5t3-28.5L519-861q-3-9-10.6-14-7.61-5-17.49-5h-22.82q-9.88 0-17.49 5.5Q443-869 440-860L280-442q-6 15 3.24 28.5t25.31 13.5q10.45 0 18.45-6t12-15l37-103Zm21-55 82-230h2l82 230H397Z"
		/>
	</svg>
);
